<template>
  <div>
    <live />
  </div>
</template>

<script>
import { debounce } from 'lodash-es';

import Live from './Live.vue';

import EventBus from '../utils/event-bus';
import SessionStore from '../utils/sessionStorage';
import youtube from '../utils/youtube';
import facebook from '../utils/facebook';

const onResize = debounce(() => {
  EventBus.$emit('resize');
}, 500);

export default {
  components: {
    Live,
  },

  beforeCreate() {
    SessionStore('tgb_display_nums', null);
    SessionStore('tgb_display_nums_counter', null);
  },

  created() {
    window.addEventListener('resize', onResize);
  },

  mounted() {
    youtube.loadYoutubeApi();
    facebook.init();

    if (this.$route.query?.disable_animations === 'true') {
      document.body.classList.add('disable-anims');
    }

    this.$store.dispatch('initDisplay', this.$route);
  },

  beforeUnmount() {
    window.removeEventListener('resize', onResize);
  },
};
</script>
